import React, { useEffect, useState } from 'react';
import './SpecificSubmodelDetails.scss';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import Swal from 'sweetalert2';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
const SpecificSubModelDetails = ({ globalSubmodel, data, sendClick, uuid_from_main, submodel_from_main, onAction }) => {
    const [expandedKeys, setExpandedKeys] = useState({});
    const [checkedKeys, setCheckedKeys] = useState({});
    const [editable, setEditable] = useState({});

    const aasHost = process.env.REACT_APP_AAS_HOST;
    const aasWritePort = process.env.REACT_APP_AAS_WRITE_PORT;
    console.log("Which UUID", uuid_from_main, submodel_from_main, data)


    const doTheThing = (finalFinalThing) => {
        var sixChars = finalFinalThing.substring(0, 6);

        if (sixChars.startsWith("curren")) {
            sixChars = "current";
        }
        if (sixChars.startsWith("self")) {
            sixChars = "self";
        }
        if (sixChars.startsWith("first_")) {
            sixChars = "first_seen";
        }
        if (sixChars.startsWith("id")) {
            sixChars = "id";
        }
        if (sixChars.startsWith("last_s")) {
            sixChars = "last_seen";
        }
        if (sixChars.startsWith("manufa")) {
            sixChars = "manufacturer";
        }
        if (sixChars.startsWith("memory")) {
            sixChars = "memory_slot_count";
        }
        if (sixChars.startsWith("model")) {
            sixChars = "model";
        }
        if (sixChars.startsWith("name")) {
            sixChars = "name";
        }
        if (sixChars.startsWith("proces")) {
            sixChars = "processor_slot_count";
        }
        if (sixChars.startsWith("seria")) {
            sixChars = "serial";
        }
        if (sixChars.startsWith("system")) {
            sixChars = "system.id";
        }
        if (sixChars.startsWith("versio")) {
            sixChars = "version";
        }
        if (sixChars.startsWith("bootab")) {
            sixChars = "bootable";
        }
        if (sixChars.startsWith("format")) {
            sixChars = "format";
        }
        if (sixChars.startsWith("free")) {
            sixChars = "free";
        }
        if (sixChars.startsWith("hard_d")) {
            sixChars = "hard_drive_index";
        }
        if (sixChars.startsWith("mount_")) {
            sixChars = "mount_point";
        }
        if (sixChars.startsWith("partit")) {
            sixChars = "partition_disk_index";
        }
        if (sixChars.startsWith("size")) {
            sixChars = "size";
        }
        if (sixChars.startsWith("system")) {
            sixChars = "system_id";
        }
        if (sixChars.startsWith("type")) {
            sixChars = "type";
        }
        if (sixChars.startsWith("used")) {
            sixChars = "used";
        }
        if (sixChars.startsWith("archit")) {
            sixChars = "architecture";
        }
        if (sixChars.startsWith("core_c")) {
            sixChars = "core_count";
        }
        if (sixChars.startsWith("descri")) {
            sixChars = "description";
        }
        if (sixChars.startsWith("hyper")) {
            sixChars = "hyperthreading";
        }
        if (sixChars.startsWith("alias")) {
            sixChars = "alias";
        }
        if (sixChars.startsWith("availa")) {
            sixChars = "available";
        }
        if (sixChars.startsWith("connec")) {
            sixChars = "connection";
        }
        if (sixChars.startsWith("connec")) {
            sixChars = "connection_status";
        }
        if (sixChars.startsWith("days_s")) {
            sixChars = "days_since_changed";
        }
        if (sixChars.startsWith("dhcp_e")) {
            sixChars = "dhcp_enabled";
        }
        if (sixChars.startsWith("dhcp_l")) {
            sixChars = "dhcp_lease_expires";
        }
        if (sixChars.startsWith("dhcp_l")) {
            sixChars = "dhcp_lease_obtained";
        }
        if (sixChars.startsWith("dhcp_s")) {
            sixChars = "dhcp_server";
        }
        if (sixChars.startsWith("dns_do")) {
            sixChars = "dns_domain";
        }
        if (sixChars.startsWith("dns_do")) {
            sixChars = "dns_domain_reg_enabled";
        }
        if (sixChars.startsWith("dns_ho")) {
            sixChars = "dns_host_name";
        }
        if (sixChars.startsWith("dns_se")) {
            sixChars = "dns_server";
        }
        if (sixChars.startsWith("ifadmi")) {
            sixChars = "ifadminstatus";
        }
        if (sixChars.startsWith("iflast")) {
            sixChars = "iflastchange";
        }
        if (sixChars.startsWith("ip_ena")) {
            sixChars = "ip_enabled";
        }
        if (sixChars.startsWith("mac")) {
            sixChars = "mac";
        }
        if (sixChars.startsWith("manufa")) {
            sixChars = "manufacturer";
        }
        if (sixChars.startsWith("net_in")) {
            sixChars = "net_index";
        }
        if (sixChars.startsWith("slaves")) {
            sixChars = "slaves";
        }
        if (sixChars.startsWith("speed")) {
            sixChars = "speed";
        }
        if (sixChars.startsWith("logica")) {
            sixChars = "logical_count";
        }
        if (sixChars.startsWith("physic")) {
            sixChars = "physical_count";
        }
        if (sixChars.startsWith("socket")) {
            sixChars = "socket";
        }
        if (sixChars.startsWith("bank")) {
            sixChars = "bank";
        }
        if (sixChars.startsWith("tag")) {
            sixChars = "tag";
        }
        if (sixChars.startsWith("form_f")) {
            sixChars = "form_factor";
        }
        if (sixChars.startsWith("end_of")) {
            sixChars = "end_of_life";
        }


        return sixChars;
    };
    // Initialize checkedKeys based on the data object
    useEffect(() => {
        const initializeCheckedKeys = (obj, parentKey = '') => {
            Object.entries(obj).forEach(([key, value]) => {
                const currentKey = parentKey ? `${parentKey}.${key}` : key;
                setCheckedKeys(prevKeys => ({ ...prevKeys, [currentKey]: false })); // Initialize all to unchecked
                if (typeof value === 'object' && value !== null) {
                    initializeCheckedKeys(value, currentKey); // Recursive initialization
                }
            });
        };

        initializeCheckedKeys(data);
    }, [data]);

    const toggleExpansion = (key) => {
        setExpandedKeys(prevKeys => ({
            ...prevKeys,
            [key]: !prevKeys[key]
        }));
    };

    const handleCheckboxChange = (key, isChecked) => {
        setCheckedKeys(prevKeys => {
            const updatedKeys = { ...prevKeys };

            // Update the current key
            updatedKeys[key] = isChecked;

            // Function to recursively update children based on the parent's state
            const updateChildKeys = (obj, parentKey, check) => {
                Object.keys(obj).forEach(k => {
                    const childKey = `${parentKey}.${k}`;
                    updatedKeys[childKey] = check;
                    if (typeof obj[k] === 'object' && obj[k] !== null) {
                        updateChildKeys(obj[k], childKey, check);
                    }
                });
            };

            // Get the direct children and update
            const currentObj = getObjectByKey(data, key); // Helper function to get the object by key
            if (currentObj) {
                updateChildKeys(currentObj, key, isChecked);
            }

            return updatedKeys;
        });
    };

    const logCheckedKeys = () => {
        const logValue = (key, obj) => {
            const keys = key.split('.');
            let value = obj;
            for (const k of keys) {
                if (value && typeof value === 'object') {
                    value = value[k];
                } else {
                    value = undefined;
                    break;
                }
            }
            if (value !== undefined) {
                console.log(key, value);
            }
        };

        Object.keys(checkedKeys).forEach((key) => {
            if (checkedKeys[key]) {
                logValue(key, data);
            }
        });
    };


    const getObjectByKey = (obj, key) => {
        const keys = key.split('.');
        let result = obj;
        for (let i = 0; i < keys.length; i++) {
            result = result[keys[i]];
            if (!result) return null;
        }
        return result;
    };
    function countCharacterOccurrences(str, char) {
        return str.split(char).length - 1;
    }

    const handleUpgradeClick = (currentKey, value) => {
        // Log the field and value when UpgradeIcon is clicked
        console.log("Field:", currentKey, "Value:", value);
        console.log("Which UUID", uuid_from_main, submodel_from_main)

        if (submodel_from_main === "Nameplate") {
            //alert("This is a f***ing nameplate")
            var submodelElement = {
                "modelType": {
                    "name": "Property"
                },
                "kind": "Instance",
                "value": `${value}`,//<== value
                "valueType": "string",
                "idShort": `${currentKey}`,
                "parent": {
                    "keys": [
                        {
                            "type": "Submodel",
                            "local": true,
                            "value": `${submodel_from_main}`,
                            "idType": "Custom"
                        }
                    ]
                }
            }

            console.log(submodelElement)
            var fixEdUrl = encodeURIComponent(`${uuid_from_main}`)
            var fixedSubModelElement = encodeURIComponent(`${currentKey}`)
            if (currentKey === "type" || currentKey === "uuid") {
                Swal.fire({
                    title: 'Error!',
                    text: 'Cannot update this field',
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
            if (currentKey === "model" && editable.model !== "") {
                var diti = {
                    "conceptDictionary": [],
                    "identification": {
                        "idType": "Custom",
                        "id": `${uuid_from_main}`//`${idShort}`
                    },
                    "idShort": `${editable.model}_${uuid_from_main}`,//`${name}`,
                    "dataSpecification": [],
                    "modelType": {
                        "name": "AssetAdministrationShell",
                    },
                    "asset": {
                        "identification": {
                            "idType": "Custom",
                            "id": `${uuid_from_main}`
                        },
                        "idShort": `${uuid_from_main}`,
                        "kind": "Instance",
                        "dataSpecification": [],
                        "modelType": {
                            "name": "Asset"
                        },
                        "category": `computer`,
                        "embeddedDataSpecifications": []
                    },
                    "embeddedDataSpecifications": [],
                    "views": [],
                    "submodels": [
                        {
                            "keys": [
                                {
                                    "type": "Submodel",
                                    "idType": "Custom",
                                    "value": "string",
                                    "local": true
                                }
                            ]
                        }
                    ],
                }

                upload(diti);

                fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${fixedSubModelElement}`, {
                    method: "PUT",
                    body: JSON.stringify(submodelElement),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            //console.log("WE ARE HERE MF");
                            // Swal.fire({
                            //     title: 'Update Successful!',
                            //     icon: 'success',
                            //     confirmButtonText: 'Cool'
                            // })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                // console.error("ERROR", response.status, errorText);
                                // Swal.fire({
                                //     title:"Update unsuccesful!",
                                //     icon: 'error',
                                //     confirmButtonText: 'Cool'
                                // })
                            });
                        }
                    })
                    .catch(error => {
                        // Handle any network or fetch-related errors
                        console.error("FETCH ERROR", error);
                    });
            }
            if (currentKey !== "type" && currentKey !== "uuid") {
                fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${fixedSubModelElement}`, {
                    method: "PUT",
                    body: JSON.stringify(submodelElement),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log("WE ARE HERE MF");
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                    .catch(error => {
                        // Handle any network or fetch-related errors
                        console.error("FETCH ERROR", error);
                    });
            }

        }
        //-------------------------------------- BoM Staff ----------------------------------
        if (submodel_from_main === "BoM") {
            if (currentKey.includes(".")) {
                console.log(currentKey.split('.')[0], currentKey.split('.')[1], currentKey.split('.')[2],)

                var fixEdUrl = encodeURIComponent(`${uuid_from_main}`)
                if (countCharacterOccurrences(currentKey, ".") === 2) {
                    fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[0]}/${currentKey.split(".")[1]}/${currentKey.split(".")[2]}/value`, {
                        method: "PUT",
                        body: JSON.stringify(value),
                    }).then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log(response);
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                            fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[2]}`, {
                                method: "DELETE",
                            }).then(response => { console.error("WE DELETED AS WELL THE " + currentKey.split(".")[2]) })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                        .catch(error => {
                            // Handle any network or fetch-related errors
                            console.error("FETCH ERROR", error);
                        });
                }
                if (countCharacterOccurrences(currentKey, ".") === 1) {
                    fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[0]}/${currentKey.split(".")[1]}/value`, {
                        method: "PUT",
                        body: JSON.stringify(value),
                    }).then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log(response);
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                            fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[1]}`, {
                                method: "DELETE",
                            }).then(response => { console.error("WE DELETED AS WELL THE " + currentKey.split(".")[1]) })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                        .catch(error => {
                            // Handle any network or fetch-related errors
                            console.error("FETCH ERROR", error);
                        });
                }


            }
        }


    };
    async function upload(diti) {
        var fixEdUrl = encodeURIComponent(`${diti.identification.id}`)
        const mares = await fetch(`/aasServer/shells/${fixEdUrl}`, {
            method: "PUT",
            body: JSON.stringify(diti),
        })

        const res = await mares.status;


        if (res === 200) {
            //setReRender(current => !current)
            // const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/Service/submodel`, {
            //   method: "PUT",
            //   body: JSON.stringify(diti2),
            // })
            // console.log(mares.json())
            //createTheAsset()
            Swal.fire({
                title: 'Update Successful!',
                icon: 'success',
                confirmButtonText: 'OK'
            })
            onAction();

        }
        else {
            Swal.fire({
                title: 'Update Unsuccessful!',
                icon: 'Error',
                confirmButtonText: 'OK'
            })
        }

    }

    const renderItems = (obj, parentKey = '') => {
        const entries = Object.entries(obj);
        const objEntries = entries.filter(([, v]) => typeof v === 'object' && v !== null);
        const valEntries = entries.filter(([, v]) => typeof v !== 'object' || v === null);

        return (
            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                {valEntries.map(([key, value]) => {
                    const isEmpty = value === null || value === undefined || value === "" || value === "N/A";
                    return (
                        <div key={parentKey ? `${parentKey}.${key}` : key} style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <div style={{ fontSize: "11px", fontWeight: "600", color: "#7c7c7c", letterSpacing: "0.02em" }}>{key}</div>
                            <div style={{
                                background: "#f8f8f8", border: "1px solid #d3d3d3",
                                borderRadius: "4px", padding: "5px 10px",
                                fontSize: "11.5px", fontFamily: "'Courier New', monospace",
                                color: isEmpty ? "#bbb" : "#202020",
                                fontStyle: isEmpty ? "italic" : "normal",
                                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                transition: "border-color 0.12s",
                            }}
                                onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(38,144,68,0.4)"}
                                onMouseLeave={e => e.currentTarget.style.borderColor = "#d3d3d3"}
                            >
                                {isEmpty ? "N/A" : String(value)}
                            </div>
                        </div>
                    );
                })}
                {objEntries.map(([key, value]) => {
                    const currentKey = parentKey ? `${parentKey}.${key}` : key;
                    return (
                        <div key={currentKey}>
                            <div style={{
                                fontSize: "11px", fontWeight: "700", letterSpacing: "0.06em",
                                textTransform: "uppercase", color: "#7c7c7c",
                                padding: "6px 0 4px",
                                display: "flex", alignItems: "center", gap: "8px"
                            }}>
                                <span>{key}</span>
                                <span style={{ flex: 1, height: "1px", background: "#d3d3d3", display: "block" }} />
                            </div>
                            {renderItems(value, currentKey)}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "12px 14px 10px", flexShrink: 0 }}>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Type</span>
                    <span style={{ background: "#f1f1f1", border: "1px solid #d3d3d3", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#202020", fontWeight: "600" }}>Submodel</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Name</span>
                    <span style={{ background: "rgba(38,144,68,0.08)", border: "1px solid rgba(38,144,68,0.3)", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#269044", fontWeight: "600" }}>{globalSubmodel}</span>
                </div>
            </div>
            <div style={{ height: "1px", background: "#d3d3d3", flexShrink: 0 }} />
            <div style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c", padding: "8px 14px 6px", flexShrink: 0 }}>
                {globalSubmodel !== "BoM" ? "Properties" : "Elements"}
            </div>
            <div style={{ flex: 1, overflow: "auto", padding: "0 14px 12px" }}>
                {renderItems(data)}
            </div>
        </div>
    );
};

export default SpecificSubModelDetails;



